export default __webpack_public_path__ + "static/media/IMG_0900.75baba0c.75baba0c.JPG";